"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var targetFolderMruConfiguration_1 = require("owa-service/lib/factory/targetFolderMruConfiguration");
var targetFolderMRUEntry_1 = require("owa-service/lib/factory/targetFolderMRUEntry");
var setFolderMruConfigurationOperation_1 = require("owa-service/lib/operation/setFolderMruConfigurationOperation");
/**
 * Action to set folder Mru Configuration
 * @param folderMruEntries - list of folder mru entries to save to server
 */
function setFolderMruConfigurationService(folderMruEntries) {
    var targetFolderIds = folderMruEntries.map(function (id) {
        return targetFolderMRUEntry_1.default({ EwsFolderIdEntry: id });
    });
    var mruConfiguration = targetFolderMruConfiguration_1.default({ FolderMruEntries: targetFolderIds });
    return setFolderMruConfigurationOperation_1.default({
        folderMruConfiguration: mruConfiguration,
    }).then(function (response) {
        return response;
    });
}
exports.default = setFolderMruConfigurationService;
//# sourceMappingURL=setFolderMruConfigurationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/services/setFolderMruConfigurationService.js
// module id = 3669
// module chunks = 51